export default __webpack_public_path__ + "static/media/nki.2205ccdf.png";